import type { ReactNode } from "react";

import { Toaster } from "@/components/ui/sonner";
import { NotificationsProvider } from "@/contexts/notifications-context";
import { useFlash } from "@/hooks/use-flash";

interface PersistentLayoutProps {
  children: ReactNode;
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  useFlash();

  return (
    <NotificationsProvider>
      {children}
      <Toaster richColors position="top-center" />
    </NotificationsProvider>
  );
}
